<template>
    <!--专题详情 -->
    <div class="specialwrap">
        <v-downTip :popShow="popShow" ></v-downTip>
        <v-shareHeader :content="shareSwiper"></v-shareHeader>
        <v-shareFooter :content="shareSwiper"></v-shareFooter>
        <img class="logo" :src="datainfo.imageAddr" alt="">
        <div class="content" v-text="datainfo.introduction"></div>
        <div class="contentHtml" v-html="datainfo.content"></div>
        <div class="listbox">
        <h3>
          -- 热门报告 --
        </h3>
        <ul>
            <li class="clearfix" v-for="(item,index) in datainfo.reportList" @click="toStore" :key="index">
                <div class="clearfix  listinfo">
                    <img :src="item.headImage ? item.headImage :require('../images/headerImg.png')" alt="">
                    <div class="rightwrap">
                        <div class="righttitle" v-text="item.title"></div>
                        <div class="companyinfo">
                            <span v-text="item.bigshotName" class="username"></span>
                            <span v-text="item.positionName" class="positionName"></span>
                        </div>
                    </div>
                </div>
                <div class="readTotal">
                    <img src="../images/eye.png" alt="">
                    阅读 {{item.readTotal}}
                </div>
            </li>
        </ul>
      </div>
      <v-morerepeat :actionId="$route.query.accountId" :shareSwiper="shareSwiper" :isshare="true" :datatype="15"></v-morerepeat>
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
      datainfo:"",
      token:"",
      popShow:false,
      shareSwiper:'',
    }
  },
  created(){
    this.init();
  },
  mounted(){
    weixin.shareInfo(15,this.$route.query.contentId,this.$route.query.accountId)
    weixin.shareTitle(15,this.$route.query.contentId,(data)=>{
      this.shareSwiper = data;
    });
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.shareSwiper)
    },
    closeTip(){
      this.popShow = false;
    },
    getToken(token){
      //this.token = token;
    },
    init(){
        //http://preh.funeralchain.com/#/sharereportInfo?contentId=5b1dd356eda7050001c0b043&accountId=272&bigShotId=272
        this.$http.get("/content/classroom/industrySpeciaDetails?id="+this.$route.query.contentId)
				.then((response) => {
                    this.datainfo=response.respData
	    });
    },
  }
}
</script>
<style lang="less" scoped>
    .specialwrap{
        background: #FBF6F6;
        margin-bottom: 150px;
        .logo{
            width: 100%;
            height: 500px;
        }
        .content{
            background: #fff;
            padding: 20px 30px;
            font-size: 28px;
            color: #5B5C66;
            line-height: 40px;
        }
        .contentHtml{
            padding: 20px 30px;
            background: #fff;
        }
        ul{
            li{
                .listinfo{
                    img{
                        width: 120px;
                        height: 120px;
                        float: left;
                        margin-left:30px;
                        margin-top: 28px;
                        border-radius: 50%;
                    }
                    .rightwrap{
                        float: left;
                        margin-left: 20px;
                        width: 550px;
                        .righttitle{
                            margin-top:15px;
                            height: 84px;
                            font-size: 28px;
                            color: #333440;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }
                        .companyinfo{
                            margin-top:8px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            .username{
                                font-size:24px;
                                color: #5B5C66;
                            }
                            .positionName{
                                font-size:24px;
                                color: #A4A4A4;
                            }
                        }
                    }
                }
                .readTotal{
                    float: right;
                    font-size: 22px;
                    color: #A4A4A4;
                    margin-right: 32px;
                    margin-top:12px;
                    img{
                        width: 26px;
                        height: 22px;
                        vertical-align: middle;
                    }
                }
            }
        }
        .listbox{
            margin-top:20px;
            background: #fff;
            h3{
                height: 64px;
                line-height: 64px;
                text-align: center;
                font-size:28px;
                color: #BA9E70;
                font-weight: normal;
            }
        }
    }
</style>
<style lang="less">
  .specialwrap{
    .contentHtml{
        font-size:32px;
        img,video,table{
        max-width: 100%;
        }
    } 
    
  }
</style>




// WEBPACK FOOTER //
// src/share/sharespecial.vue